"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var react_idle_timer_1 = require("react-idle-timer");
var useToken_1 = __importDefault(require("./useToken"));
var useIdleTimeout = function (_a) {
    var isIdleDialog = _a.isIdleDialog, isIdleDisabled = _a.isIdleDisabled;
    var timeout = 1000 * 60 * 60;
    var promptBeforeIdle = 1000 * 60 * 5;
    var token = useToken_1.default();
    var _b = react_1.useState(timeout), remaining = _b[0], setRemaining = _b[1];
    var idleTimer = react_idle_timer_1.useIdleTimer({
        timeout: timeout,
        promptBeforeIdle: promptBeforeIdle,
        onPrompt: !isIdleDisabled ? isIdleDialog.setTrue : undefined,
        onIdle: !isIdleDisabled ? token.logout : undefined,
        debounce: 500,
    });
    react_1.useEffect(function () {
        var interval = setInterval(function () {
            setRemaining(Math.ceil(idleTimer.getRemainingTime()));
        }, 1000);
        return function () {
            clearInterval(interval);
        };
    });
    return {
        idleTimer: idleTimer,
        remaining: remaining,
    };
};
exports.default = useIdleTimeout;
